import { fromQueryString } from '../../utility';
import { useMemo } from 'react';
import { useLocation } from '@reach/router';

export interface QueryParamObject {
  [k: string]: string[];
}

/**
 * Frontend routers don't seem to want to parse the query, so this does that.
 */
export const useQueryParams = () => {
  const location = useLocation();

  let locationSearch = '';
  if (undefined !== location) {
    locationSearch = location.search;
  }

  const result: QueryParamObject = useMemo(() => {
    const queryParamsRaw = fromQueryString(locationSearch);
    const queryParams: QueryParamObject = {};

    // Unfortunately, we get string|string[] from the parse.
    // It is potentially easier to use this to get a single value:
    //    const [value] = result.value;
    // than to deal with getting an array from a string
    for (const key of Object.keys(queryParamsRaw)) {
      const value = queryParamsRaw[key];
      if (value && value !== '') {
        if (Array.isArray(value)) {
          queryParams[key] = value;
        } else {
          queryParams[key] = [value];
        }
      }
    }

    return new Proxy(queryParams, {
      get(target: any, property) {
        // Default to an empty array of anything that was
        // not found (to prevent destructuring errors)
        return Object.prototype.hasOwnProperty.call(target, property)
          ? target[property]
          : [];
      }
    });
  }, [locationSearch]);

  return result;
};
